export const SET_PLACE = '[PLACE] SET'
export const START_LOADING = '[PLACE] START_LOADING'
export const END_LOADING = '[PLACE] END_LOADING'
export const UPDATE_PLACE_INFO = '[PLACE] UPDATE INFO'
export const UPDATE_PLACE_CONTACT_DETAIL = '[PLACE] UPDATE CONTACT DETAIL'
export const UPDATE_PLACE_BY_PROP = '[PLACE] UPDATE PLACE'
export const UPDATE_INTERESTED_BEACON = '[USER] SET UPDATE INTERESTED BEACON'
export const DISMISS_PLACE_MESSAGE = 'DISMISS_PLACE_MESSAGE'
export const DISMISS_PLACE_ALL_MESSAGES = 'DISMISS_PLACE_ALL_MESSAGES'
export const UPDATE_TOGGLE_LANDING = 'UPDATE_TOGGLE_LANDING'
export const UPDATE_LANDING_CREATED = 'UPDATE_LANDING_CREATED'
export const UPDATE_LANDING_PLACE_NAME = 'UPDATE_LANDING_PLACE_NAME'

export function setPlace(place) {
  return {
    type: SET_PLACE,
    place,
  }
}

export function dismissPlaceMessage(id) {
  return {
    type: DISMISS_PLACE_MESSAGE,
  }
}

export function dismissPlaceAllMessages() {
  return {
    type: DISMISS_PLACE_ALL_MESSAGES,
  }
}

export function startLoading() {
  return {
    type: START_LOADING,
  }
}

export function endLoading() {
  return {
    type: END_LOADING,
  }
}

export function updatePlaceInfo(field, value) {
  return {
    type: UPDATE_PLACE_INFO,
    field,
    value,
  }
}

export function updatePlaceContactDetail(values) {
  return {
    type: UPDATE_PLACE_CONTACT_DETAIL,
    values,
  }
}

export function updatePlaceByProp(field, value) {
  return {
    type: UPDATE_PLACE_BY_PROP,
    field,
    value,
  }
}

export function updateInterestedBeacon(value) {
  return {
    type: UPDATE_INTERESTED_BEACON,
    value: value,
  }
}
export function updateToggleLanding(value) {
  return {
    type: UPDATE_TOGGLE_LANDING,
    value: value,
  }
}

export function updateLandingCreated(value) {
  return {
    type: UPDATE_LANDING_CREATED,
    value: value,
  }
}

export function updateLandingPlaceName(value) {
  return {
    type: UPDATE_LANDING_PLACE_NAME,
    value: value,
  }
}
